import { Component, OnInit } from '@angular/core';
import { PageDataService } from 'src/app/services/page-data.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-where-to-watch-page',
    templateUrl: './where-to-watch-page.component.html',
    styleUrls: ['./where-to-watch-page.component.scss']
})
export class WhereToWatchPageComponent implements OnInit {
    isMobile: boolean = false;

    constructor(
        public pageData: PageDataService,
        private breakpointObserver: BreakpointObserver,
    ) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });
    }

    ngOnInit(): void {
    }

    onOpenSizzleOverlay(path: string) {
        this.pageData.openOverlay(path)
    }
}
